import { useAuth } from '@/lib'
import { AccountProvisioningPendingScreen } from '@/ui'
import { roleEnum } from '@jobilla/nexus-sdk'
import { OpenFeature } from '@openfeature/react-sdk'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_auth')({
	beforeLoad: ({ context, location }) => {
		const { auth } = context
		if (!auth.isSignedIn) {
			throw redirect({
				to: '/auth',
				search: location.pathname !== '/' ? { redirect: location.pathname } : {},
			})
		}

		if (
			auth.user
			&& auth.user.isProvisioned
			&& !auth.user.onboardingCompletedAt
			&& auth.role !== roleEnum.jobillan
			&& !auth.user.email.toLowerCase().endsWith('@jobilla.com')
			&& !location.pathname.startsWith('/onboarding')
		) {
			throw redirect({ to: '/onboarding' })
		}
	},
	component: AuthLayout,
})

function AuthLayout() {
	const { user } = useAuth()

	useEffect(() => {
		if (user?.id) {
			void OpenFeature.setContext({ ...OpenFeature.getContext(), targetingKey: user.id })
		}
	}, [user?.id])

	if (!user) {
		return null
	}

	if (!user.isProvisioned) {
		return <AccountProvisioningPendingScreen />
	}

	return <Outlet />
}
